import { TextField, MenuItem, InputAdornment, Select, InputLabel, FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Field } from "formik";
// import { TextField } from "@mui/material";
// import { useTranslation } from "react-i18next";

export const TextFieldCustom = ({ name, label, formik, type = "text", grid = 4, ...props }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <Field name={name}>
      {({ field, form }) => (
        <TextField
          fullWidth
          variant="filled"
          type={type}
          label={label}
          {...field} // يتضمن name, value, onChange, onBlur
          error={!!form.touched[name] && !!form.errors[name]}
          helperText={form.touched[name] && form.errors[name]}
          sx={{
            gridColumn: `span ${grid}`,
            direction: isRTL ? "rtl" : "ltr",
            "& .MuiInputBase-input": {
              textAlign: isRTL ? "right" : "left",
              direction: isRTL ? "rtl" : "ltr",
            },
          }}
          InputLabelProps={{
            shrink: true,
            sx: {
              textAlign: isRTL ? "right" : "left",
              right: isRTL ? "24px" : undefined,
              transformOrigin: isRTL ? "right top" : "left top",
              fontSize: "20px",
            },
          }}
          inputProps={{
            style: {
              paddingRight: isRTL ? "14px" : undefined,
              paddingLeft: isRTL ? undefined : "14px",
            },
            ...props.inputProps,
          }}
          {...props}
        />
      )}
    </Field>
  );
};

export const NumberField = ({ name, label, formik, currency = true, grid = 2, ...props }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <TextField
      fullWidth
      variant="filled"
      type="number"
      label={label}
      name={name}
      onBlur={formik.handleBlur}
      onChange={formik.handleChange}
      value={formik.values[name]}
      error={!!formik.touched[name] && !!formik.errors[name]}
      helperText={formik.touched[name] && formik.errors[name]}
      sx={{
        gridColumn: `span ${grid}`,
        '& .MuiInputBase-input': {
          textAlign: isRTL ? "right" : "left",
          direction: "ltr" 
        }
      }}
      InputLabelProps={{
        shrink: true,
        sx: { 
          textAlign: isRTL ? "right" : "left",
          right: isRTL ? "24px" : undefined,
        //   left: isRTL ? undefined : "24px",
          transformOrigin: isRTL ? "right top" : "left top",
          fontSize:'20px'
        }
      }}
    //   InputProps={{
    //     startAdornment: currency && (
    //     //   <InputAdornment position="start" sx={{ mr: isRTL ? 5 : 1, ml: isRTL ? 5 : 3 }}>
    //     //     {isRTL ? "" : "EGP"}
    //     //   </InputAdornment>
    //     )
    //   }}
      {...props}
    />
  );
};

export const DateField = ({ name, label, formik, grid = 2 }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <TextField
      fullWidth
      variant="filled"
      type="date"
      label={label}
      name={name}
      onBlur={formik.handleBlur}
      onChange={formik.handleChange}
      value={formik.values[name]}
      error={!!formik.touched[name] && !!formik.errors[name]}
      helperText={formik.touched[name] && formik.errors[name]}
      sx={{
        gridColumn: `span ${grid}`,
        "& .MuiInputBase-input": {
          textAlign: isRTL ? "right" : "left",
          paddingRight: isRTL ? "12px" : "32px",
          paddingLeft: isRTL ? "32px" : "12px"
        },
        "& input[type='date']::-webkit-calendar-picker-indicator": {
          position: "absolute",
          left: isRTL ? "12px" : "auto",
          right: isRTL ? "auto" : "12px",
          marginRight: isRTL ? "0" : "10px",
          marginLeft: isRTL ? "10px" : "0",
          filter: isRTL ? "none" : "invert(0.5)"
        }
      }}
      InputLabelProps={{
        shrink: true,
        sx: { 
          transformOrigin: isRTL ? "right top" : "left top",
          right: isRTL ? "32px" : undefined,
          fontSize: '20px'
        }
      }}
      inputProps={{
        max: new Date().toISOString().split("T")[0]
      }}
    />
  );
};




export const SelectField = ({ name, label, options, formik, grid = 4 }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <FormControl
      fullWidth
      variant="filled"
      sx={{
        gridColumn: `span ${grid}`,
        direction: isRTL ? "rtl" : "ltr",
        "& .MuiSelect-select": {
          textAlign: isRTL ? "right" : "left",
          paddingRight: isRTL ? "12px !important" : "32px !important",
          paddingLeft: isRTL ? "32px !important" : "12px !important",
        },
        "& .MuiSelect-icon": {
          left: isRTL ? "12px" : "auto",
          right: isRTL ? "auto" : "12px",
        },
      }}
    >
      <InputLabel
        sx={{
          textAlign: isRTL ? "right" : "left",
          transformOrigin: isRTL ? "right top" : "left top",
          right: isRTL ? "32px" : undefined,
          fontSize: "15px",
          padding: "7px 4px 2px 2px",
        }}
      >
        {label}
      </InputLabel>
      <Select
        name={name}
        value={formik.values[name] || ""} // التأكد من أن القيمة ليست undefined
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={!!formik.touched[name] && !!formik.errors[name]}
        MenuProps={{
          PaperProps: {
            sx: {
              direction: isRTL ? "rtl" : "ltr",
              "& .MuiMenuItem-root": {
                justifyContent: isRTL ? "flex-end" : "flex-start",
              },
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label ? option.label : t(option.labelKey)} {/* دعم label و labelKey */}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};


